import { create } from '@/store'
import { devtools } from 'zustand/middleware'
import { saveQueueId } from '@/utils/auth.js'

const initialCallee = {
  username: '',
  sipGatewayUrl: '',
  sipPass: '',
  agentId: '',
  hotline: '',
}

const initialCaller = {
  name: '',
  avatar: '',
  gender: '',
  dob: '',
  numberPhone: '',
  group: '',
}

const initialCallInfo = {
  callId: '',
  ticketId: '',
  callStatus: '',
  callType: '',
  campaignId: '',
}

const useCallStore = create(
  devtools(
    (set) => ({
      isActivatingVoice: false,
      isSocketConnected: false,
      isSipConnected: false,
      callee: initialCallee,
      caller: initialCaller,
      callInfo: initialCallInfo,
      currentNumberCall: '',
      callStatus: '',
      queueId: '',
      startTime: '',
      isAutoAnswer: false,
      isClickToCall: false,
      isInCall: false,
      audioTrack: null,
      lastCallEndedAt: null,
      positionInCall: { x: 50, y: 0 },
      setIsActivatingVoice: (IsActivatingVoice) =>
        set({ isActivatingVoice: IsActivatingVoice }),
      setIsSocketConnected: (isConnected) =>
        set({ isSocketConnected: isConnected }),
      setIsSipConnected: (isConnected) => set({ isSipConnected: isConnected }),
      setCallee: (callee) =>
        set((state) => ({ callee: { ...state.callee, ...callee } })),
      setCaller: (caller) =>
        set((state) => ({ caller: { ...state.caller, ...caller } })),
      setCallInfo: (callInfo) =>
        set((state) => ({ callInfo: { ...state.callInfo, ...callInfo } })),
      setIsAutoAnswer: (status) => set({ isAutoAnswer: status }),
      setCallStatus: (status) => set({ callStatus: status }),
      setCurrentNumberCall: (number) => set({ currentNumberCall: number }),
      setStartTime: (time) => set({ startTime: time }),
      setIsInCall: (status) => set({ isInCall: status }),
      setQueueId: (id) => {
        saveQueueId(id)
        set({ queueId: id })
      },
      setIsClickToCall: (state) => set({ isClickToCall: state }),
      setPositionInCall: (position) => set({ positionInCall: position }),
      setAudioTrack: (track) => set({ audioTrack: track }),
      setLastCallEndedAt: (data) =>
        set((state) => ({ ...state, lastCallEndedAt: data })),
      resetCallInfo: () =>
        set({
          callInfo: initialCallInfo,
        }),
      resetCallee: () =>
        set({
          callee: initialCallee,
        }),
      resetCaller: () =>
        set({
          caller: initialCaller,
        }),
      resetCall: () =>
        set({
          caller: initialCaller,
          callInfo: initialCallInfo,
          audioTrack: null,
          isClickToCall: false,
          callStatus: 'ENDED',
        }),
    }),
    {
      name: 'call-store',
    },
  ),
)

export default useCallStore
